<ng-container class="ion-padding-vertical" *ngFor="let date of dates">
  <ion-accordion class="ion-padding-start">
    <ion-item-sliding slot="header" #slide>
      <ion-label class="ion-text-start">
        <h2 style="color: #8358C5; margin: 10px; border-bottom: 1px solid #8358C5;">{{ date | date: 'EEE, dd MMM yyyy' }}</h2>
      </ion-label>

      <ng-container *ngIf="((associative[date]?.time.length > 0) && hasActualTimeEntry(associative[date]?.time)) || (associative[date]?.expense.length > 0); else noTimesOrExpenses">
        <ion-label *ngIf="associative[date]?.time.length > 0" class="ion-text-start">
          <h4 style="color:grey; padding-left: 10px;">Times</h4>
        </ion-label>
        <ng-container class="ion-padding-vertical" *ngFor="let item of filterOutPublicHolidayPlaceholders(associative[date]?.time)">
          <ion-item detail="true" style="margin-bottom: 5px; cursor: pointer;" (click)="editTime(item.id)" class="ion-activatable">
            <ion-label class="ion-text-start">
              <h2>{{ item.project_name ?? 'No Project' }}</h2>
              <h4>{{ item.item_category_name }}</h4>
            </ion-label>
            <ion-chip [color]="getIconColorByState(item.item_state_tech_key)">
              <ion-icon [color]="getIconColorByState(item.item_state_tech_key)" [name]="getIconNameByState(item.item_state_tech_key)"></ion-icon>
              <ion-label>{{ formatHours(item.hours) }}</ion-label>
            </ion-chip>
          </ion-item>
        </ng-container>

        <ion-label *ngIf="associative[date]?.expense.length > 0">
          <h4 style="color:grey; padding-left: 10px;">Expenses</h4>
        </ion-label>
        <ng-container class="ion-padding-vertical" *ngFor="let item of associative[date]?.expense">
          <ion-item detail="true" style="margin-bottom: 5px; cursor: pointer;" (click)="editExpense(item.id)" class="ion-activatable">
            <ion-label class="ion-text-start">
              <h2>{{ item.project_name ?? 'No Project' }}</h2>
              <h4>{{ item.item_category_name }}</h4>
            </ion-label>
            <ion-chip [color]="getIconColorByState(item.item_state_tech_key)">
              <ion-icon [color]="getIconColorByState(item.item_state_tech_key)" [name]="getIconNameByState(item.item_state_tech_key)"></ion-icon>
              <ion-label>{{ item.quantity + " " + item.currency }}</ion-label>
            </ion-chip>
          </ion-item>
        </ng-container>
      </ng-container>
    </ion-item-sliding>
  </ion-accordion>
</ng-container>

<ng-template #noTimesOrExpenses>
  <ion-label>
    <h4 style="color:grey; padding-left: 10px;">No times or expenses.</h4>
  </ion-label>
</ng-template>
